/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-26 08:00:56
 *
 *******************************************************/
// @flow

import React from 'react';
import { Icon, Stack, TextStyle } from '@shopify/polaris';
import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';
import { change, Field, getFormValues } from 'redux-form';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { withI18n } from '@shopify/react-i18n';
import { MobileVerticalDotsMajor } from '@shopify/polaris-icons';
import { connect } from 'react-redux';
import _ from 'lodash';
import { RenderSelect } from 'src/components/views/common/forms/render-select';

const FILTER_OPTIONS = [
  {
    label: 'Vendor',
    value: 'vendor'
  },
  {
    label: 'Collection',
    value: 'collection'
  },
  {
    label: 'Category',
    value: 'product_category'
  },
  {
    label: 'Product Type',
    value: 'product_type'
  }
];
const ScopedSuggestion = props => {
  const { i18n, scopedSuggestions, enableNewSearch, isDisableSuggestion } = props;

  if (!enableNewSearch) {
    return <></>;
  }

  const op1 = FILTER_OPTIONS.map(op => {
    if (scopedSuggestions.option2 && op.value === scopedSuggestions.option2) {
      return { ...op, disabled: true };
    }
    return op;
  });
  const op2 = FILTER_OPTIONS.map(op => {
    if (scopedSuggestions.option1 && op.value === scopedSuggestions.option1) {
      return { ...op, disabled: true };
    }
    return op;
  });

  return (
    <div className="scopedSuggestionWrap">
      <Field
        name="scopedSuggestions.applyScopedSuggestion"
        component={RenderToggleSwitch}
        disabled={isDisableSuggestion}
        label={i18n.translate(
          'AdminHTML.InstantSearchDisplay.ISWWithResults.enableScopedSuggestion_Label'
        )}
      />
      {scopedSuggestions.applyScopedSuggestion && (
        <div className="groupFields">
          <RenderLabelTooltip
            label={
              <span style={{ fontWeight: 400 }}>
                {i18n.translate(
                  'AdminHTML.InstantSearchDisplay.ISWWithResults.enableScopedSuggestion_Content'
                )}
              </span>
            }
            size="lg"
            tooltip={
              <div>
                <p>
                  {i18n.translate(
                    'AdminHTML.InstantSearchDisplay.ISWWithResults.scopedSuggestion_FilterTooltip1'
                  )}
                </p>
                <p style={{ marginTop: 15 }}>
                  {i18n.translate(
                    'AdminHTML.InstantSearchDisplay.ISWWithResults.scopedSuggestion_FilterTooltip2',
                    {
                      t1: (
                        <TextStyle variation={'strong'}>
                          {i18n.translate(
                            'AdminHTML.InstantSearchDisplay.ISWWithResults.scopedSuggestion_FilterTooltip2_T1'
                          )}
                        </TextStyle>
                      )
                    }
                  )}
                </p>
                <p>
                  {i18n.translate(
                    'AdminHTML.InstantSearchDisplay.ISWWithResults.scopedSuggestion_FilterTooltip3'
                  )}
                </p>
                <ul style={{ marginTop: 5 }}>
                  <li>
                    <p>
                      {i18n.translate(
                        'AdminHTML.InstantSearchDisplay.ISWWithResults.scopedSuggestion_FilterTooltip4'
                      )}
                    </p>
                  </li>
                </ul>
              </div>
            }
          />
          <Stack distribution="leading" alignment="center">
            <Icon color="subdued" source={MobileVerticalDotsMajor} />
            <Field name="scopedSuggestions.option1" component={RenderSelect} options={op1} />
          </Stack>
          <Stack distribution="leading" alignment="center">
            <Icon color="subdued" source={MobileVerticalDotsMajor} />
            <Field name="scopedSuggestions.option2" component={RenderSelect} options={op2} />
          </Stack>
          <p style={{ fontWeight: 400, paddingTop: 16, color: '#6D7175' }}>
            {i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.enableScopedSuggestion_Note',
              {
                t: (
                  <strong>
                    {i18n.translate(
                      'AdminHTML.InstantSearchDisplay.ISWWithResults.enableScopedSuggestion_Note_t'
                    )}
                  </strong>
                )
              }
            )}
          </p>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateField: (field, data) => dispatch(change('InstantSearchWidgetForm', field, data))
});

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('InstantSearchWidgetForm')(state);
  const scopedSuggestions = _.get(formValues, 'scopedSuggestions', {});
  const enableNewSearch = _.get(
    state.oauth,
    'tenantApp.settings.instantSearch.settings.enable',
    false
  );
  return {
    scopedSuggestions,
    enableNewSearch
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ScopedSuggestion));
